import { useEffect } from 'react';

export default function useTabFocusGuard({ active, isMobileDevice, registerViolation, fullscreenRequestRef }) {
  useEffect(() => {
    if (!active) return undefined;

    const handleBlur = () => {
      if (isMobileDevice) return;
      if (fullscreenRequestRef?.current) return;
      registerViolation('window_blur', 'Jangan pindah tab/jendela selama tes berlangsung.');
    };
    const handleVisibility = () => {
      if (!document.hidden) return;
      registerViolation('tab_change', 'Anda meninggalkan halaman tes. Fokus kembali untuk melanjutkan.');
    };
    const handlePageHide = () => {
      registerViolation('tab_change', 'Aplikasi atau halaman tes ditinggalkan.');
    };
    const blockCopyPaste = (e) => {
      e.preventDefault();
      registerViolation('copy_attempt', 'Copy-paste dinonaktifkan selama tes berlangsung.');
    };

    window.addEventListener('blur', handleBlur);
    document.addEventListener('visibilitychange', handleVisibility);
    window.addEventListener('pagehide', handlePageHide);
    document.addEventListener('copy', blockCopyPaste);
    document.addEventListener('paste', blockCopyPaste);
    document.addEventListener('cut', blockCopyPaste);

    return () => {
      window.removeEventListener('blur', handleBlur);
      document.removeEventListener('visibilitychange', handleVisibility);
      window.removeEventListener('pagehide', handlePageHide);
      document.removeEventListener('copy', blockCopyPaste);
      document.removeEventListener('paste', blockCopyPaste);
      document.removeEventListener('cut', blockCopyPaste);
    };
  }, [active, isMobileDevice, registerViolation, fullscreenRequestRef]);
}